// Put some common messages here
export const COAST_MESSAGES = {
    UNEXPECTED_ERROR: "Unexpected error occurred. Please try again!",
    MISSING_ACCESS_TOKEN: "We're sorry! There was an error processing your request. Please re-login and try again!",
    SUCCESSFUL_UPDATE: "Your account has been successfully updated.",
    INVALID_LINK:
        "The link you are trying to access is not valid. " +
        "Please verify the link you clicked on or request a new one.",
};
